export default __webpack_public_path__ + "static/shalini-80a444ac98fc4c5c01c41c26a8da4654.jpg";